var apiLink = 'https://api.cebraspe.org.br/';
//var apiLink = 'https://localhost:44335/';
//var apiLink = 'http://localhost/apicebraspe/';
var cdnLink = 'https://cdn.cebraspe.org.br/';

export const Config = {
    apiLink: apiLink,
    cdnLink: cdnLink,
    eventoURL: `${apiLink}eventos`,
    basename: '/vestibulares/',
    menuSuperior: 151,
    menuInformacoes: 148,
    menuServicos: 150,
    menuInstitucional: 149,
};
